module.exports = __webpack_public_path__ + "img/stamp1_thumb.cdb57414.jpg";